export enum OptimisationStatus {
    Optimal = "Optimal",
    Infeasible = "Infeasible"
}
